import ProtectedRoute from './ProtectedRoute';
import MainLayout from './MainLayout';
// import Homepage from '../components/dashboard/Homepage';

export default function RootRoute() {
  // const { isAuthenticated } = useAuthStore();
  // if (isAuthenticated) {
  return (
    <ProtectedRoute>
      <MainLayout />
    </ProtectedRoute>
  );
  // }
  // return (
  //   <PublicRoute>
  //     <Homepage />
  //   </PublicRoute>
  // );
}
